import { render } from "./SongSearchComponent.vue?vue&type=template&id=5f425b11"
import script from "./SongSearchComponent.vue?vue&type=script&lang=ts"
export * from "./SongSearchComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script